<template>
    <q-layout view="lHh Lpr lFf">
        <!-- Left Drawer Menu -->
        <q-drawer
            v-model="leftDrawerOpen"
            show-if-above
            :width="280"
            :mini="miniState"
            :mini-width="80"
            :breakpoint="1024"
            bordered
            class="modern-drawer"
        >
            <LeftMenu
                @logout="logout"
                :user="user"
                :login-out="loginOut"
                @toggle-drawer="toggleLeftDrawer"
                @toggle-mini="toggleMini"
                :is-mini="miniState"
            />
        </q-drawer>

        <!-- Toggle Button for Mobile (shows when drawer is closed on small screens) -->
        <q-page-sticky position="top-left" :offset="[18, 18]" style="z-index: 99999;">
            <q-btn
                v-if="!leftDrawerOpen"
                fab
                icon="menu"
                color="primary"
                @click="toggleLeftDrawer"
                class="toggle-menu-btn"
            >
                <q-tooltip>Abrir menú</q-tooltip>
            </q-btn>
        </q-page-sticky>

        <q-page-container>
            <slot />
        </q-page-container>

        <CartMenu v-model="isOpened" />
    </q-layout>
</template>

<script setup>
import "../boot/defaultData.js";
import AuthService from "../services/AuthService";
import CartMenu from "@/components/layoutParts/CartMenu.vue";
import LeftMenu from "@/components/layoutParts/LeftMenu.vue";
import { ref, computed } from "vue";
import { router, usePage } from "@inertiajs/vue3";
import { useCartStore } from "@/stores/useCartStore";
import { useConfigStore } from "@/stores/useConfigStore";

const configStore = useConfigStore();
const page = usePage();
const user = computed(() => page.props?.auth?.user);
const cartStore = useCartStore();
const isOpened = computed(() => cartStore.isOpened);
const leftDrawerOpen = ref(true);
const loginOut = ref(false);


const toggleLeftDrawer = () => {
    leftDrawerOpen.value = !leftDrawerOpen.value;
};

const miniState = computed(() => configStore.getSidebarMiniStatus);

const toggleMini = () => {
    configStore.toggleSidebarMini();
};

const logout = async () => {
    loginOut.value = true;
    await AuthService.logout();
    loginOut.value = false;
    router.visit("/login");
};
</script>

<style lang="scss" scoped>
.modern-drawer {
    background: #fafafa;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.08);
}

.toggle-menu-btn {
    box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
    transition: all 0.3s ease;
    z-index: 2000;

    &:hover {
        transform: scale(1.1);
        box-shadow: 0 6px 16px rgba(25, 118, 210, 0.4);
    }

    // Hide on desktop when drawer is visible
    @media (min-width: 1024px) {
        display: none;
    }
}
</style>
